<template>
  <collapse-default id="gemeos"
                    :condition="gemeos.length">
    <template v-slot:header>
      Gêmeos  {{ !gemeos.length ? ' - Nenhum informado' : '' }}
    </template>

    <template v-slot:content>
      <div v-for="( gemeo, index ) in gemeos"
           :key="`gemeo_${gemeo.gemeo_id}+${index}`"
           class="mt-3 pb-2 resumo-show_header--shadow">
        <div class="resumo-show_header--blue">
          {{ gemeo.nome || 'Não informado' }}
        </div>
        <div class="pl-4 pl-4 row">
          <div class="col-9">
            <div class="row">
              <div class="col">
                <label class="resumo-show_header--label">Matricula</label>
                <div class="resumo-show_header--sublabel">
                  {{ gemeo.matricula || 'Não informado' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "GemeosCollapse",
    components: {
      CollapseDefault
    },
    props: {
      gemeos: Array,
    }
  }
</script>

<style scoped>

</style>
